export default __webpack_public_path__ + "images/0xad6d458402f60fd3bd25163575031acdce07538d.png";